import React, { useContext, useState, useEffect } from 'react';
import {
  getInstitutions,
  GetStudentsWithoutClassesId,
  getTeachersWithoutClassesId,
} from '../../../actions';
import { ClassesAdd } from './ClassesAdd';
import { Context } from '../../../defaults';
import { Tabs } from 'antd';
import ClassesTable from './ClassesTable';

const { TabPane } = Tabs;

const Classes = () => {
  const { dictionary, language } = useContext(Context);
  const [institutions, setInstitutions] = useState([]);
  const [students, setStudents] = useState([]);
  const [active, setActive] = useState('1');
  const [added, setAdded] = useState(false);
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    getInstitutions().then(({ data }) => setInstitutions(data));
    GetStudentsWithoutClassesId().then(({ data }) => {
      setStudents(
        data.map((el, index) => {
          return {
            ...el,
            fullName: el.lastName + ' ' + el.firstName + ' ' + el.middleName,
            key: el.id,
          };
        }),
      );
    });
    getTeachersWithoutClassesId().then(({ data }) => {
      setTeachers(
        data.map((el, index) => {
          return {
            ...el,
            fullName: el.lastName + ' ' + el.firstName + ' ' + el.middleName,
            key: el.id,
          };
        }),
      );
    });
  }, []);

  const callback = (key) => {
    setActive(key);
    setAdded(false);
  };

  return (
    <Tabs defaultActiveKey="1" activeKey={active} onChange={callback}>
      <TabPane tab={`${dictionary?.AddClass[language]}`} key="1">
        <ClassesAdd
          institutions={institutions}
          setActive={setActive}
          students={students}
          teachers={teachers}
          setAdded={setAdded}
        />
      </TabPane>
      <TabPane tab={dictionary?.ClassesList[language]} key="2">
        <div style={{ marginTop: 24 }}>
          <ClassesTable added={added} institutions={institutions} setAdded={setAdded} />
        </div>
      </TabPane>
    </Tabs>
  );
};

export default Classes;
